import { render, staticRenderFns } from "./RecrutestBanner.vue?vue&type=template&id=1d234fda&scoped=true"
import script from "./RecrutestBanner.vue?vue&type=script&lang=js"
export * from "./RecrutestBanner.vue?vue&type=script&lang=js"
import style0 from "./RecrutestBanner.vue?vue&type=style&index=0&id=1d234fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d234fda",
  null
  
)

export default component.exports